import anime from 'animejs';

import { debounce } from './utilities/debounce';

const headerContainer = document.querySelector('.header__container');
const logoSVG = document.querySelector('.header-logo__svg');
const hamburgerLineContainer = document.querySelector('.header-hamburger__line-container');

const darkColorArr = ['rgb(0, 0, 0)', 'rgb(109, 48, 214)']; // array of colors where the logo should turn white
let breaksArr, breaksAndColorsArr, currentUserYPos, headerHeight, logoTopPadding, topSectionObj;
// const headerEasing = 'spring(1, 70, 50, 0)';

// TODO: Determine how to handle eventual background images.

// This finds all the y values of the top of the different sections and footer, and the
// padding-top of the logo container. Will run on page load or window resize.
export const calculateBreaksAndColors = () => {
    const topSection = document.querySelectorAll('section')[0];
    if (topSection) {
        topSectionObj = {
            desktopColor: topSection.dataset.logoColorDesktop
                ? topSection.dataset.logoColorDesktop
                : '',
            mobileColor: topSection.dataset.logoColorMobile
                ? topSection.dataset.logoColorMobile
                : '',
            bgColor: getComputedStyle(topSection).backgroundColor
        };
    } else {
        topSectionObj = {};
    }
    headerHeight = headerContainer.offsetHeight;
    currentUserYPos = window.scrollY;
    changeLogoColor();
};

export const changeLogoColor = debounce(() => {
    const logoIsInverted = document.querySelector('.header-logo__svg--inverse') !== null;
    const isMobile = window.innerWidth <= 600;
    if (currentUserYPos < headerHeight) {
        // First, check to see if the logo color was explicitly defined via data-attribute
        let specifiedLogoColor;
        if (!isMobile) {
            specifiedLogoColor = topSectionObj.desktopColor;
        } else {
            specifiedLogoColor = topSectionObj.mobileColor;
        }

        // If the color is explicitly defined as a data-attribute, make that the logo color and return.
        if (!logoIsInverted && specifiedLogoColor === '#FFFFFF') {
            logoSVG.classList.add('header-logo__svg--inverse');
            hamburgerLineContainer.classList.add('header-hamburger__line-container--inverse');
            return;
        } else if (logoIsInverted && specifiedLogoColor === '#000000') {
            logoSVG.classList.remove('header-logo__svg--inverse');
            hamburgerLineContainer.classList.remove('header-hamburger__line-container--inverse');
            return;
        } else if (specifiedLogoColor) {
            return;
        }

        // If the color is not explicitly assigned, let's check based on background color.
        const currentBgColor = topSectionObj ? topSectionObj.bgColor : 'white';
        if (!logoIsInverted && darkColorArr.includes(currentBgColor)) {
            logoSVG.classList.add('header-logo__svg--inverse');
            hamburgerLineContainer.classList.add('header-hamburger__line-container--inverse');
            return;
        } else if (logoIsInverted && !darkColorArr.includes(currentBgColor)) {
            logoSVG.classList.remove('header-logo__svg--inverse');
            hamburgerLineContainer.classList.remove('header-hamburger__line-container--inverse');
            return;
        }
    }
}, 100);

const showOrHideHeader = debounce(() => {
    const newUserYPos = window.scrollY;
    const headerIsFixed = document.querySelector('.header__container--scrolled-down') !== null;
    const headerIsVisible = headerContainer.getAttribute('data-visible') === 'yes';
    const scrollingDown = currentUserYPos < newUserYPos;

    // First, determine whether or not we need to adjust the .header__container's CSS position attribute.
    if (!headerIsFixed && newUserYPos > headerHeight) {
        headerContainer.classList.add('header__container--scrolled-down');
        headerContainer.setAttribute('style', `transform: translateY(-${headerHeight}px)`);
        headerContainer.setAttribute('data-visible', 'no');
        addHeaderWhite();
    } else if (headerIsFixed && newUserYPos === 0) {
        headerContainer.classList.remove('header__container--scrolled-down');
        headerContainer.setAttribute('data-visible', 'yes');
        removeHeaderWhite(250);
    }

    // Next, if the user's y-position is greater than the height of the .header__container, see if we need to
    // either trigger a slide up or slide down.
    if (scrollingDown && headerIsFixed && headerIsVisible) {
        headerSlideUp();
    } else if (!scrollingDown && headerIsFixed && !headerIsVisible) {
        headerSlideDown();
    }

    // Record the user's new scroll position no matter what.
    setTimeout(() => {
        currentUserYPos = window.scrollY;
    }, 50);
}, 150);

const headerSlideUp = () => {
    anime({
        targets: '.header__container',
        translateY: -headerHeight,
        duration: 200,
        easing: 'linear',
        complete: () => {
            setTimeout(() => {
                headerContainer.setAttribute('data-visible', 'no');
            }, 250); // adding the time extra padding here to limit jank
        }
    });
};

const headerSlideDown = () => {
    anime({
        targets: '.header__container',
        translateY: 0,
        easing: 'easeOutCubic',
        duration: 250,
        complete: () => {
            headerContainer.setAttribute('data-visible', 'yes');
        }
    });
};

const addHeaderWhite = (dur = 0) => {
    anime({
        targets: '.header__container',
        backgroundColor: 'rgba(255,255,255,1)',
        easing: 'linear',
        duration: dur
    });
};

export const removeHeaderWhite = (dur = 0) => {
    anime({
        targets: '.header__container',
        backgroundColor: 'rgba(255,255,255,0)',
        easing: 'linear',
        duration: dur
    });
};

document.addEventListener('scroll', changeLogoColor);
document.addEventListener('scroll', showOrHideHeader);

window.addEventListener(
    'resize',
    debounce(() => calculateBreaksAndColors(), 150)
);

calculateBreaksAndColors();
